var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionTypeRetroImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 109,
    viewBox: "0 0 125 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25.8691,
    y: 16.5898,
    width: 83.2247,
    height: 64.9945,
    rx: 2.77093,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.2059,
    y: 16.2547,
    width: 82.5512,
    height: 64.321,
    rx: 2.4342,
    stroke: "black",
    strokeWidth: 0.673465,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 35.6123,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 35.6123,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 35.6123,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 35.6123,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 28.4785,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 28.4785,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 28.4785,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 28.4785,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#DAE9ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 50.6719,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 50.6719,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 50.6719,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 50.6719,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 43.5381,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 43.5381,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 43.5381,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 43.5381,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#DAE9ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 66.5244,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 66.5244,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 66.5244,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 66.5244,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 59.3906,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 59.3906,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 59.3906,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2188,
    y: 59.3906,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#DAE9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3821 63.8812L65.9707 60.2926L62.3821 56.7041",
    stroke: "#9BBAC1",
    strokeWidth: 2.55139,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9915 30.8047L44.8867 33.9446L47.9915 37.0846",
    stroke: "#9BBAC1",
    strokeWidth: 2.55139,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7163 45.6074L34.821 48.7473L37.9257 45.6074",
    stroke: "#9BBAC1",
    strokeWidth: 2.55139,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0608 48.7473L61.1655 45.6074L64.2702 48.7473",
    stroke: "#9BBAC1",
    strokeWidth: 2.55139,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9872 47.0873C60.9872 54.4447 55.0899 60.409 47.8151 60.409M47.8151 60.409H63.1826M47.8151 60.409L47.2606 60.3975M47.8151 60.409C42.347 60.409 37.6571 57.0393 35.665 52.241M34.6431 47.0873C34.6431 42.0455 37.4125 37.6578 41.4968 35.3954M47.8151 33.7656C53.3307 33.7656 58.0545 37.1941 60.0165 42.0588",
    stroke: "#9BBAC1",
    strokeWidth: 2.55139,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.15015 57.7313L76.5275 18.4443L8.15015 57.7313Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.618 33.9587L115.947 30.8564L110.618 33.9587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6477 88.2682L54.9768 85.166",
    stroke: "#E3DFE9",
    strokeWidth: 16.7314,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.18 77.295C114.012 77.3819 114.617 78.1276 114.53 78.9593C114.443 79.791 113.697 80.3958 112.866 80.3089C112.034 80.2221 111.429 79.4763 111.516 78.6446C111.603 77.813 112.349 77.2082 113.18 77.295Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.778901
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5396 94.7314C32.9072 94.8742 33.9017 96.1005 33.7589 97.4682C33.6161 98.8358 32.3898 99.8303 31.0221 99.6875C29.6545 99.5447 28.66 98.3184 28.8028 96.9507C28.9456 95.5831 30.1719 94.5886 31.5396 94.7314Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.28085
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6712 6.72553C61.0388 6.86833 62.0333 8.09469 61.8905 9.46234C61.7477 10.83 60.5214 11.8245 59.1537 11.6817C57.7861 11.5389 56.7916 10.3125 56.9344 8.94487C57.0772 7.57722 58.3035 6.58274 59.6712 6.72553Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.28085
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98567 38.498C2.61388 38.498 3.12393 39.0081 3.12393 39.6363C3.12393 40.2645 2.61388 40.7746 1.98567 40.7746C1.35747 40.7746 0.847412 40.2645 0.847412 39.6363C0.847412 39.0081 1.35747 38.498 1.98567 38.498Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.936249
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.536 30.9971C123.164 30.9971 123.674 31.5071 123.674 32.1353C123.674 32.7635 123.164 33.2736 122.536 33.2736C121.908 33.2736 121.398 32.7635 121.398 32.1353C121.398 31.5071 121.908 30.9971 122.536 30.9971Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.936249
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.38 5.70117L104.68 1.32113",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.912 2.8916L106.292 4.19102",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60181 80.2832L7.74105 75.8588",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03271 77.5293L9.45713 78.6685",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M101.572 100.048L102.463 95.5669",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8523 97.3857L104.333 98.2768",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTypeRetroImg);
export default __webpack_public_path__ + "static/media/question_type_retro_img.48603ddada347cbca0d436260bf981b6.svg";
export { ForwardRef as ReactComponent };